// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import translations from '../translations';
import { useLanguage } from '../LanguageContext';

const Icon = ({ name }) => {
    const common = {
        fill: "none", stroke: "currentColor", strokeWidth: "2",
        strokeLinecap: "round", strokeLinejoin: "round"
    };
    switch (name) {
        case 'inventory':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>);
        case 'raw':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" /><path d="m3.3 7 8.7 5 8.7-5" /><path d="M12 22V12" /></svg>);
        case 'suppliers':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>);
        case 'products':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" /><path d="M3 6h18" /><path d="M16 10a4 4 0 0 1-8 0" /></svg>);
        case 'dispatch':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="M10 17h4V5H2v12h3m10 0h3l4-4v-3h-7v7Z" /><circle cx="6.5" cy="17.5" r="2.5" /><circle cx="16.5" cy="17.5" r="2.5" /></svg>);
        case 'analytics':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>);
        case 'account':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>);
        case 'packaging':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v1.5" /><path d="M21 7.5H3V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7.5Z" /><path d="M12 7.5V20" /><path d="M3 12h18" /></svg>);
        case 'activity':
            return (<svg width="20" height="20" viewBox="0 0 24 24" {...common}><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>);
        case 'power':
            return (<svg width="16" height="16" viewBox="0 0 24 24" {...common} strokeWidth="2.5"><path d="M18.36 6.64a9 9 0 1 1-12.73 0" /><line x1="12" y1="2" x2="12" y2="12" /></svg>);
        default:
            return null;
    }
};

const Navbar = ({ onLogout, user, workspaceUuid, workspaceName }) => {
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

    // detect mobile breakpoint
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 720 : false);
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 720);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const handleLogoutClick = async () => {
        setIsLoggingOut(true);
        onLogout();
        setIsLoggingOut(false);
    };

    const { t, isRtl } = useLanguage();
    const wsPrefix = `/workspace/${workspaceUuid}`;

    const modals = (
        <>
            {/* Logout Confirmation Modal */}
            {showLogoutConfirm && (
                <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(26, 28, 29, 0.45)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    zIndex: 3000, backdropFilter: 'blur(4px)'
                }}>
                    <div style={{
                        width: 320, background: '#fff', borderRadius: 12, padding: 24,
                        textAlign: 'center', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
                    }}>
                        <div style={{
                            background: '#fff1f0', color: '#cf1322', width: 48, height: 48,
                            borderRadius: '50%', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', margin: '0 auto 16px'
                        }}>
                            <Icon name="power" />
                        </div>
                        <h3 style={{ margin: '0 0 8px', fontSize: 18, color: '#1a1c1d' }}>{t.logout_confirm_title}</h3>
                        <p style={{ margin: '0 0 24px', fontSize: 13, color: '#6d7175' }}>{t.logout_confirm_msg}</p>
                        <div style={{ display: 'flex', gap: 12, flexDirection: isRtl ? 'row-reverse' : 'row' }}>
                            <button
                                onClick={() => setShowLogoutConfirm(false)}
                                style={{ flex: 1, padding: '10px', borderRadius: 8, border: '1px solid #d2d2d2', background: '#fff', fontSize: 14, cursor: 'pointer' }}
                            >{t.cancel_btn}</button>
                            <button
                                onClick={() => { setShowLogoutConfirm(false); handleLogoutClick(); }}
                                style={{ flex: 1, padding: '10px', borderRadius: 8, border: 'none', background: '#dc2626', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}
                            >{t.logout_btn}</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Logging Out Loader */}
            {isLoggingOut && (
                <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    zIndex: 4000, backdropFilter: 'blur(8px)'
                }}>
                    <div className="custom-loader" style={{
                        width: 40, height: 40, border: '3px solid #f3f3f3',
                        borderTop: '3px solid #1976d2', borderRadius: '50%',
                        animation: 'spin 1s linear infinite', marginBottom: 16
                    }}></div>
                    <div style={{ fontWeight: 600, color: '#1a1c1d', letterSpacing: '0.05em' }}>{t.logging_out}</div>
                    <style>{`
                        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                    `}</style>
                </div>
            )}
        </>
    );

    if (isMobile) {
        // mobile horizontal nav (fixed bottom)
        return (
            <>
                <nav style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    borderTop: '1px solid #eef0f2',
                    boxShadow: '0 -4px 20px rgba(0,0,0,0.05)',
                    padding: '0 16px',
                    zIndex: 1200,
                    gap: 4
                }}>
                    <NavLink to={`${wsPrefix}/all-inventory`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="inventory" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/raw-materials`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="raw" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/products`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="products" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/packing-materials`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="packaging" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/dispatch`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="dispatch" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/analysis`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="analytics" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/management`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="suppliers" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/activity`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="activity" /></span>}
                    </NavLink>
                    <NavLink to={`${wsPrefix}/account`} style={({ isActive }) => ({ color: isActive ? '#4318FF' : '#94A3B8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 8 })}>
                        {({ isActive }) => <span style={{ width: 24, height: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: isActive ? '#4318FF' : '#64748b' }}><Icon name="account" /></span>}
                    </NavLink>
                    <button
                        onClick={() => setShowLogoutConfirm(true)}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 44,
                            height: 44,
                            borderRadius: 8,
                            color: '#64748b'
                        }}
                    >
                        <Icon name="power" />
                    </button>
                </nav>
                {modals}
            </>
        );
    }

    // Desktop: Premium Sidebar with refined aesthetics
    return (
        <>
            <nav className="sidebar" style={{
                width: '215px',
                height: '100vh',
                backgroundColor: '#f9fafb',
                padding: '0',
                position: 'fixed',
                top: 0,
                [isRtl ? 'right' : 'left']: 0,
                display: 'flex',
                flexDirection: 'column',
                borderLeft: isRtl ? '1px solid #eef0f2' : 'none',
                borderRight: isRtl ? 'none' : '1px solid #eef0f2',
                zIndex: 1100,
                direction: isRtl ? 'rtl' : 'ltr'
            }}>
                {/* Premium Logo Section */}
                <div className="sidebar-logo-section" style={{
                    padding: '24px 20px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    borderBottom: '1px solid #eef0f2',
                    marginBottom: 8,
                    direction: isRtl ? 'rtl' : 'ltr'
                }}>
                    {/* Logo and App Name - Left Aligned */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexDirection: isRtl ? 'row-reverse' : 'row' }}>
                        <img src="/omniTraceLogo.png" alt="OmniTraceX" style={{ height: 28, width: 'auto', objectFit: 'contain', transform: isRtl ? 'scaleX(-1)' : 'none' }} />
                        <div style={{ fontWeight: 800, fontSize: 16, color: '#1a1c1d', letterSpacing: '-0.02em', textAlign: isRtl ? 'right' : 'left' }}>OmniTrace<span style={{ color: '#1976d2' }}>X</span></div>
                    </div>

                    {/* Workspace Name - Centered */}
                    {workspaceName && (
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <div style={{
                                fontSize: '11px',
                                fontWeight: 700,
                                color: '#1976d2',
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em',
                                background: '#e6f4f1',
                                padding: '2px 10px',
                                borderRadius: '4px',
                                textAlign: 'center',
                                maxWidth: '90%'
                            }}>
                                {workspaceName}
                            </div>
                        </div>
                    )}
                </div>

                {/* Sidebar Links */}
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, padding: '8px 0' }}>
                    <NavLink to={`${wsPrefix}/all-inventory`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="inventory" /></span>
                        <span>{t.all_inventory}</span>
                    </NavLink>

                    <div className="sidebar-category">{t.inventory_category}</div>

                    <NavLink to={`${wsPrefix}/raw-materials`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="raw" /></span>
                        <span>{t.raw_materials}</span>
                    </NavLink>

                    <NavLink to={`${wsPrefix}/products`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="products" /></span>
                        <span>{t.products}</span>
                    </NavLink>

                    <NavLink to={`${wsPrefix}/packing-materials`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="packaging" /></span>
                        <span>{t.packing_materials}</span>
                    </NavLink>

                    <NavLink to={`${wsPrefix}/dispatch`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="dispatch" /></span>
                        <span>{t.dispatch}</span>
                    </NavLink>

                    <NavLink to={`${wsPrefix}/analysis`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="analytics" /></span>
                        <span>{t.analysis}</span>
                    </NavLink>

                    <div className="sidebar-category">{t.management_category}</div>

                    <NavLink to={`${wsPrefix}/management`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="suppliers" /></span>
                        <span>{t.management}</span>
                    </NavLink>
                    <NavLink to={`${wsPrefix}/activity`} className="sidebar-link">
                        <span style={{ display: 'flex' }}><Icon name="activity" /></span>
                        <span>{t.activities}</span>
                    </NavLink>

                    <div style={{ marginTop: 'auto', paddingBottom: 16 }}>
                        <div style={{ height: '1px', background: '#eef0f2', margin: '0 24px 16px 24px' }}></div>
                        <div style={{ position: 'relative' }}>
                            <NavLink to={`${wsPrefix}/account`} className="sidebar-link" style={{ paddingRight: 48 }}>
                                <span style={{ display: 'flex' }}><Icon name="account" /></span>
                                <div style={{ display: 'flex', flexDirection: 'column', textAlign: isRtl ? 'right' : 'left' }}>
                                    <span>{t.settings}</span>
                                    {user?.name && (
                                        <div style={{ fontSize: '10px', color: '#6d7175', fontWeight: 600, marginTop: -1 }}>
                                            {user.name}
                                        </div>
                                    )}
                                </div>
                            </NavLink>
                            <button
                                onClick={() => setShowLogoutConfirm(true)}
                                style={{
                                    position: 'absolute',
                                    [isRtl ? 'left' : 'right']: 16,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#6d7175',
                                    padding: '8px',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={e => {
                                    e.currentTarget.style.background = '#fee2e2';
                                    e.currentTarget.style.color = '#dc2626';
                                }}
                                onMouseOut={e => {
                                    e.currentTarget.style.background = 'transparent';
                                    e.currentTarget.style.color = '#6d7175';
                                }}
                                title={t.logout_btn}
                            >
                                <Icon name="power" />
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            {modals}
        </>
    );
};

export default Navbar;
